module.exports = __webpack_public_path__ + "img/94e6b937-ce80-40a3-a55d-025a830a8a04.3ebbd8eb.jpg";